<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Poll from '@/components/timeline/promoted/Poll';
import Info from '@/components/timeline/promoted/Info';
import { getPusherInstance } from '@/utils';
import _ from 'lodash';
import Speaker from '../timeline/promoted/Speaker.vue';
export default {
  name: 'TimelineDataProvider',
  props: {
    applicablePlatforms: {
      type: Array,
      default: () => ['digital']
    }
  },
  created() {
    this.loadTimelineData();
    getPusherInstance().bind('timeline-change', () => this.loadTimelineData());

    getPusherInstance().bind('timeline-modified', (data) =>
      this.updateTimelineItem(data)
    );

    getPusherInstance().bind('timeline-remove', (data) =>
      this.removeTimelineItem(data)
    );

    getPusherInstance().bind('timeline-add', (data) =>
      this.addTimelineItem(data)
    );

    getPusherInstance().bind('timeline-add-comment', (data) =>
      this.addTimelineComment(data)
    );

    getPusherInstance().bind('timeline-modified-comment', (data) =>
      this.updateTimelineComment(data)
    );

    getPusherInstance().bind('timeline-remove-comment', (data) =>
      this.removeTimelineComment(data)
    );

    getPusherInstance().bind('promoted-message-modified', (data) =>
      this.updatePromotedMessage(data)
    );

    getPusherInstance().bind('promoted-message-remove', (data) => {
      this.removePromotedMessage(data);
    });

    getPusherInstance().bind('promoted-message-add', (data) => {
      this.addPromotedMessage(data);
    });
  },
  methods: {
    ...mapActions('Timeline', [
      'loadTimelineData',
      'resetPromotedPage',
      'addTimelineItem',
      'updateTimelineItem',
      'addPromotedMessage',
      'updatePromotedMessage',
      'removePromotedMessage'
    ]),
    ...mapActions('Stream', ['setStreamFromSession']),
    ...mapMutations('Timeline', [
      'setMode',
      'resetMode',
      'addTimelineComment',
      'updateTimelineComment',
      'removeTimelineItem',
      'removeTimelineComment'
    ])
  },
  computed: {
    ...mapGetters('Timeline', [
      'getTimelineItems',
      'getPromotedTimelineItems',
      'getMode',
      'getPromotedPage'
    ]),
    getPromotedPageComponent() {
      if (!this.getPromotedPage.page) {
        return;
      }
      switch (this.getPromotedPage.page) {
        case 'poll':
        case 'quiz':
        case 'treasure_hunt':
        case 'coded_quizzes':
        case 'coded_polls':
          return Poll;
        case 'speaker':
          return Speaker;
        case 'info':
          return Info;
        case 'session':
          this.setStreamFromSession(this.getPromotedPage);
      }

      return null;
    }
  },
  render() {
    return this.$scopedSlots.default({
      timelineItems: this.getTimelineItems.filter(
        (i) =>
          _.intersection(this.applicablePlatforms, i.PlatformDisplayOptions)
            .length > 0
      ),
      promotedTimelineItems: this.getPromotedTimelineItems.filter(
        (i) =>
          _.intersection(this.applicablePlatforms, i.PlatformDisplayOptions)
            .length > 0
      ),
      mode: this.getMode,
      promotedPage: this.getPromotedPage,
      resetPromotedPage: this.resetPromotedPage,
      promotedPageComponent: this.getPromotedPageComponent
    });
  }
};
</script>
